export const getChannelId = () => {
  return 'infopank';
};
